module.exports = __webpack_public_path__ + "static/img/home_qr_sc.7fe23a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_qr_sc.png
// module id = c2Da
// module chunks = 62